import { render, staticRenderFns } from "./ordinal.vue?vue&type=template&id=01220923&scoped=true&"
import script from "./ordinal.vue?vue&type=script&lang=js&"
export * from "./ordinal.vue?vue&type=script&lang=js&"
import style0 from "./ordinal.vue?vue&type=style&index=0&id=01220923&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01220923",
  null
  
)

export default component.exports